import { createRouter, createWebHistory } from 'vue-router';
import Home from '../components/Home.vue';
import About from '../components/About.vue';
import Other from '../components/Other.vue';
import WebGuide from '../components/WebGuide.vue';
import Contact from '../components/Contact.vue';

import SalesWebsite from '../components/ServicesDetail/SalesWebsite.vue';
import LandingDesignWebsite from '../components/ServicesDetail/LandingDesignWebsite.vue';
import EcomSiteWebsite from '../components/ServicesDetail/EcomSiteWebsite.vue';
import BlogDesignWebsite from '../components/ServicesDetail/BlogDesignWebsite.vue';
import StudentHelp from '../components/ServicesDetail/StudentHelp.vue';
import AdServices from '../components/ServicesDetail/AdServices.vue';

import WorkingProcess from '@/components/WorkingProcess.vue';
import NotFound from '@/components/404NotFound.vue';
import PrivacyPolicy from '@/components/PrivacyPolicy.vue';
import TermsOfService from '@/components/TermsOfService.vue';
import Blog from '@/components/Blog.vue';
import ProxyArticle from '@/components/BlogDetail/ProxyArticle.vue';
import VpnArticle from '@/components/BlogDetail/VpnArticle.vue';
import ChatGptArticle from '@/components/BlogDetail/ChatGptArticle.vue';
import CoreWebVitals2025 from '@/components/BlogDetail/CoreWebVitals2025.vue';
import DNSPrivacyDoHDoT from '@/components/BlogDetail/DNSPrivacyDoHDoT.vue';
import LeakTestFix from '@/components/BlogDetail/LeakTestFix.vue';
import LetsEncryptNginx from '@/components/BlogDetail/LetsEncryptNginx.vue';
import PromptsMarketing2025 from '@/components/BlogDetail/PromptsMarketing2025.vue';
import VPNvsProxyTor from '@/components/BlogDetail/VPNvsProxyTor.vue';
import WireGuardUbuntu from '@/components/BlogDetail/WireGuardUbuntu.vue';
import Vue3CompositionAPI from '@/components/BlogDetail/Vue3CompositionAPI.vue';
import CoreWebVitals2025Advanced from '@/components/BlogDetail/CoreWebVitals2025Advanced.vue';
import ContentCalendar from '@/components/ContentCalendar.vue';

const routes = [
  {
    path: '/',
    component: Home,
    meta: {
        title: 'Trang chủ - Thiết kế website chuẩn SEO',
        description: 'Dịch vụ thiết kế website chuyên nghiệp tại Việt Nam. Tối ưu SEO, tốc độ cao, giao diện responsive. Hotline: 0905 514 868'        
    }
  },
  {
    path: '/about',
    component: About,
    meta: {
      title: 'Giới thiệu - Dịch vụ thiết kế website',
      description: 'Đội ngũ developer và designer chuyên nghiệp với 5+ năm kinh nghiệm. Cam kết bảo trì trọn đời và hỗ trợ 24/7'
    }
  },
  {
    path: '/contact',
    component: Contact,
    meta: {
      title: 'Liên hệ - Thiết kế website',
      description: 'Tư vấn miễn phí về thiết kế website và SEO. Liên hệ qua hotline 0905 514 868, Zalo hoặc form liên hệ trực tiếp'
    }
  },
  {
    path: '/web-guide',
    component: WebGuide,
    meta: {
      title: 'Cẩm nang thiết kế website',
      description: 'Hướng dẫn chi tiết về quy trình thiết kế website từ A-Z. Bao gồm SEO, bảo mật, tối ưu tốc độ và các công cụ hữu ích'
    }
  },
  {
    path: '/social-services',
    component: Other,
    meta: {
      title: 'Dịch vụ mạng xã hội',
      description: 'Chạy quảng cáo Facebook Ads hiệu quả, tăng tương tác trên TikTok, Instagram, Thread. Chiến lược marketing social media chuyên nghiệp'
    }
  },
  {
    path: '/thiet-ke-website-ban-hang-ca-nhan',
    component: SalesWebsite,
    meta: {
      title: 'Thiết kế website bán hàng cá nhân',
      description: 'Website bán hàng cá nhân với giao diện độc quyền, tích hợp thanh toán đa dạng, quản lý đơn hàng thông minh. Tăng doanh số 300%'
    }
  },
  {
    path: '/thiet-ke-website-landing-page',
    component: LandingDesignWebsite,
    meta: {
      title: 'Thiết kế website Landing Page',
      description: 'Landing page chuyên nghiệp tối ưu chuyển đổi, A/B testing, tích hợp CRM. Tăng tỷ lệ chuyển đổi từ 2% lên 15%'
    }
  },
  {
    path: '/thiet-ke-website-thuong-mai-dien-tu',
    component: EcomSiteWebsite,
    meta: {
      title: 'Thiết kế website thương mại điện tử',
      description: 'Website e-commerce đầy đủ tính năng: quản lý kho, thanh toán online, tích hợp shipping. Hỗ trợ bán hàng đa kênh'
    }
  },
  {
    path: '/thiet-ke-website-blog',
    component: BlogDesignWebsite,
    meta: {
      title: 'Thiết kế website Blog cá nhân',
      description: 'Blog cá nhân/gia đình với giao diện độc đáo, quản lý nội dung dễ dàng, tích hợp social media. Lưu giữ kỷ niệm đáng nhớ'
    }
  },
  {
    path: '/thiet-ke-do-an-website',
    component: StudentHelp,
    meta: {
        title: 'Thiết kế đồ án website cho sinh viên',
        description: 'Hỗ trợ sinh viên làm đồ án website từ ý tưởng đến triển khai. Tư vấn công nghệ, code review, đảm bảo đạt điểm cao'        
    }
  },
  {
    path: '/chay-quang-cao-website',
    component: AdServices,
    meta: {
      title: 'Dịch vụ chạy quảng cáo website',
      description: 'Chạy quảng cáo Facebook Ads, Google Ads hiệu quả. Tối ưu ngân sách, nhắm mục tiêu chính xác, ROI cao nhất'
    }
  },
  {
    path: '/quy-trinh-thiet-ke-website',
    component: WorkingProcess,
    meta: {
      title: 'Quy trình thiết kế website chuyên nghiệp',
      description: 'Quy trình 6 bước thiết kế website: tư vấn, ký hợp đồng, thiết kế, phát triển, test, bàn giao. Minh bạch và chuyên nghiệp'
    }
  },
  {
    path: '/chinh-sach-bao-mat',
    component: PrivacyPolicy,
    meta: {
      title: 'Chính sách bảo mật - Dịch vụ thiết kế website',
      description: 'Chính sách bảo mật thông tin cá nhân khi sử dụng dịch vụ thiết kế website. Cam kết bảo vệ dữ liệu khách hàng theo chuẩn quốc tế'
    }
  },
  {
    path: '/dieu-khoan-su-dung',
    component: TermsOfService,
    meta: {
      title: 'Điều khoản sử dụng - Dịch vụ thiết kế website',
      description: 'Điều khoản sử dụng dịch vụ thiết kế website, quy định về bản quyền, thanh toán và các điều kiện sử dụng website'
    }
  },
  {
    path: '/blog',
    component: Blog,
    meta: {
      title: 'Blog Kiến Thức - Chia sẻ kinh nghiệm thiết kế website',
      description: 'Blog chia sẻ kiến thức về thiết kế website, SEO, công nghệ và các kỹ thuật hữu ích cho doanh nghiệp. Cập nhật xu hướng mới nhất'
    }
  },
  {
    path: '/content-calendar',
    component: ContentCalendar,
    meta: {
      title: 'Content Calendar 2026 - Kế hoạch nội dung chi tiết',
      description: 'Content Calendar chi tiết với 30+ bài viết chất lượng cao về SEO, Web Development, Digital Marketing và Case Studies để khắc phục vấn đề Low-value content'
    }
  },
  {
    path: '/blog/proxy-la-gi',
    component: ProxyArticle,
    meta: {
      title: 'Proxy là gì? Hướng dẫn sử dụng Proxy Server 2024',
      description: 'Tìm hiểu về Proxy server, cách hoạt động, lợi ích và hướng dẫn sử dụng Proxy để bảo mật và tăng tốc độ truy cập internet.'
    }
  },
  {
    path: '/blog/vpn-bao-mat-mang',
    component: VpnArticle,
    meta: {
      title: 'VPN - Bảo mật mạng và bảo vệ dữ liệu cá nhân 2024',
      description: 'Hướng dẫn sử dụng VPN để bảo vệ dữ liệu cá nhân, truy cập an toàn và vượt qua các hạn chế địa lý. So sánh các loại VPN tốt nhất.'
    }
  },
  {
    path: '/blog/10-ky-thuat-prompt-chatgpt',
    component: ChatGptArticle,
    meta: {
      title: '10 kỹ thuật prompt ChatGPT hiệu quả nhất 2024',
      description: 'Khám phá 10 kỹ thuật viết prompt ChatGPT hiệu quả để tận dụng tối đa sức mạnh AI trong công việc và cuộc sống.'
    }
  },
  {
    path: '/blog/core-web-vitals-2025',
    component: CoreWebVitals2025,
    meta: {
      title: 'Core Web Vitals 2025: LCP, CLS, INP – tối ưu nhanh cho website',
      description: 'Core Web Vitals 2025: LCP, CLS, INP – cách tối ưu nhanh cho website'
    }
  },
  {
    path: '/blog/dns-over-https-tls',
    component: DNSPrivacyDoHDoT,
    meta: {
      title: 'Bật DNS-over-HTTPS/TLS (DoH/DoT) trên Windows, macOS, Android',
      description: 'Bật DNS-over-HTTPS/TLS (DoH/DoT) trên Windows, macOS, Android'
    }
  },
  {
    path: '/blog/chan-ro-ri-ip-dns-webrtc',
    component: LeakTestFix,
    meta: {
      title: 'Kiểm tra & chặn rò rỉ IP/DNS/WebRTC trong 5 phút',
      description: 'Kiểm tra & khắc phục rò rỉ IP/DNS/WebRTC trong 5 phút'
    }
  },
  {
    path: '/blog/lets-encrypt-certbot-nginx-2025',
    component: LetsEncryptNginx,
    meta: {
      title: "Let's Encrypt + Certbot: Cài SSL miễn phí cho Nginx (2025)",
      description: "Let's Encrypt + Certbot: Cài SSL miễn phí cho Nginx (2025)"
    }
  },
  {
    path: '/blog/prompt-marketing-seo-2025',
    component: PromptsMarketing2025,
    meta: {
      title: "20 prompt Marketing/SEO 'cắm là chạy' (2025)",
      description: '20 prompt "cắm là chạy" cho Marketing/SEO năm 2025'
    }
  },
  {
    path: '/blog/vpn-vs-proxy-vs-tor-2025',
    component: VPNvsProxyTor,
    meta: {
      title: 'VPN vs Proxy vs Tor: Khác nhau và dùng khi nào? (2025)',
      description: 'VPN vs Proxy vs Tor: Khác nhau ở đâu và dùng khi nào? (2025)'
    }
  },
  {
    path: '/blog/wireguard-ubuntu-vps-2025',
    component: WireGuardUbuntu,
    meta: {
      title: 'WireGuard VPS Ubuntu: Cài & cấu hình nhanh (2025)',
      description: 'WireGuard VPS Ubuntu: Cài & cấu hình nhanh (2025)'
    }
  },
  {
    path: '/blog/core-web-vitals-2025-advanced',
    component: CoreWebVitals2025Advanced,
    meta: {
      title: 'Core Web Vitals 2025: Hướng dẫn tối ưu LCP, CLS, INP từ A-Z',
      description: 'Hướng dẫn chi tiết về Core Web Vitals 2025: LCP, CLS, INP với code examples và best practices để tối ưu hiệu suất website.'
    }
  },
  {
    path: '/blog/vue3-composition-api',
    component: Vue3CompositionAPI,
    meta: {
      title: 'Vue 3 Composition API: Hướng dẫn từ cơ bản đến nâng cao',
      description: 'Hướng dẫn chi tiết về Vue 3 Composition API với examples thực tế và best practices cho developers.'
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound,
    meta: {
        title: '404 - Trang không tìm thấy',
        description: 'Trang bạn tìm kiếm không tồn tại. Vui lòng kiểm tra lại đường dẫn hoặc quay về trang chủ.'        
    }
  }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    // Click vào một đường link trong Vue Router và trang tự động cuộn lên đầu trang
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
          return savedPosition;
        } else {
          return { top: 0 };
        }
      },
});

// Thêm logic cập nhật meta title và description
router.afterEach((to) => {
  // Cập nhật title
  document.title = to.meta.title || 'Default Title';

  // Cập nhật meta description
  const metaDescription = document.querySelector('meta[name="description"]');
  if (metaDescription) {
    metaDescription.setAttribute('content', to.meta.description || 'Default description');
  } else {
    const meta = document.createElement('meta');
    meta.name = 'description';
    meta.content = to.meta.description || 'Default description';
    document.head.appendChild(meta);
  }

   // Cập nhật thẻ canonical
   const canonical = document.querySelector('link[rel="canonical"]');
   if (canonical) {
     canonical.setAttribute('href', window.location.href);
   } else {
     const link = document.createElement('link');
     link.rel = 'canonical';
     link.href = window.location.href;
     document.head.appendChild(link);
   }
});

export default router;
